import { createAsyncThunk } from '@reduxjs/toolkit';

import { emailQuote, getQuote } from 'shared/api/apiQuote';
import { selectAssemblyDataForQuote } from 'mx_pcb_assembly/store/selectors';

export const doQuote = createAsyncThunk(
  'mxAssembly/doQuote',
  async (_args, thunkAPI) => {
    const { variant, parameters } = selectAssemblyDataForQuote(thunkAPI.getState());
    const token = document.getElementsByName('authenticity_token')[0].value;

    const data = { ...parameters };
    if (data.quantities) {
      data.quantities = data.quantities.map((q) => q.toString());
    }

    const promise = getQuote({
      data, token, variant, quoteNumber: parameters.product_quote_number,
    });

    return promise
      .then((res) => res.data)
      .catch((error) => thunkAPI.rejectWithValue({ error: error.message }));
  },
);


export const doEmailQuote = createAsyncThunk(
  'mxAssembly/doEmailQuote',
  async (args, thunkAPI) => {
    const token = document.getElementsByName('authenticity_token')[0].value;
    const { data } = args;

    const promise = emailQuote({ data, token });

    return promise
      .then((res) => res.data)
      .catch((error) => thunkAPI.rejectWithValue({ error: error.message }));
  },
);
